const emptyModel = {
  id: null,
  domain: 'default',
  username: '',
  name: '',
  email: '',
  password: '',
  client_id: null,
  role_id: null,
  max_concurrent_listeners: 1
}

const emptyFilters = {
  name: undefined,
  email: undefined,
  client_id: undefined
}

export default {
  emptyModel,
  emptyFilters
}
